// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4164) return "js/2613ee04c0a1fe64d7a3.js";
	// return url for filenames based on template
	return "" + "vendor" + ".js?v=" + "88f27133a0f630138edc" + "";
};